// Skeleton — Phase 17 redesign pass.
//
// Lightweight skeleton loader components for loading states across
// the marketplace. Replaces "animate-pulse text" placeholder with
// proper pulsing rectangles + shimmer.
//
// Usage:
//   <Skeleton width={160} height={14} />
//   <Skeleton variant="line" />
//   <PluginCardSkeleton />  (preset for Browse page)

export function Skeleton({ width, height = 14, variant, className = '', style = {} }) {
  const presets = {
    line:   { width: '100%', height: 14 },
    text:   { width: 160,    height: 14 },
    title:  { width: 220,    height: 22 },
    avatar: { width: 32,     height: 32, borderRadius: '50%' },
    block:  { width: '100%', height: 80 },
    button: { width: 100,    height: 32, borderRadius: 8 },
  };
  const p = presets[variant] || {};
  return (
    <span
      className={`hz-skel inline-block ${className}`}
      style={{
        display: 'inline-block',
        width: width || p.width || 160,
        height: height || p.height || 14,
        background: 'linear-gradient(90deg, rgba(255,255,255,0.04) 0%, rgba(255,255,255,0.10) 50%, rgba(255,255,255,0.04) 100%)',
        backgroundSize: '200% 100%',
        borderRadius: p.borderRadius || 6,
        animation: 'hzSkelShimmer 1.6s ease-in-out infinite, hzSkelPulse 1.6s ease-in-out infinite',
        pointerEvents: 'none',
        userSelect: 'none',
        ...style,
      }}
    />
  );
}

/** Plugin-card placeholder — matches PluginCard.jsx layout. */
export function PluginCardSkeleton() {
  return (
    <div className="rounded-2xl border border-white/10 bg-white/[0.02] p-5 flex flex-col gap-3">
      <div className="flex items-center gap-3">
        <Skeleton variant="avatar" />
        <div className="flex flex-col gap-1.5">
          <Skeleton width={140} height={16} />
          <Skeleton width={80} height={11} />
        </div>
      </div>
      <Skeleton width="92%" height={12} />
      <Skeleton width="76%" height={12} />
      <div className="flex items-center justify-between mt-2">
        <Skeleton width={60} height={20} />
        <Skeleton width={84} height={28} style={{ borderRadius: 8 }} />
      </div>
    </div>
  );
}

/** Reusable shimmer keyframes — drop once anywhere in the app */
export function SkeletonStyles() {
  return (
    <style>{`
      @keyframes hzSkelShimmer {
        0%   { background-position: 200% 0; }
        100% { background-position: -200% 0; }
      }
      @keyframes hzSkelPulse {
        0%, 100% { opacity: 0.45; }
        50%      { opacity: 0.85; }
      }
    `}</style>
  );
}
